import styled from 'styled-components';


export const BioWrapper = styled.div`
display: flex;
width: 100vw;
// background-color: tomato;
align-self: center;
justify-content: center;
padding-top: 80px;
flex-wrap: wrap;
gap: 10px;

@media (max-width: 769px){
    padding-top: 30px;
    gap: 5px;
}
`;


export const Person = styled.div`
background-color: white;
display: flex;
flex-direction: column;
width: 400px;
align-items: center;
justify-content: center;
padding-top: 20px;
padding-bottom: 20px;
margin-left: 20px;
margin-right: 20px;
// border: 1px solid #0E8FD8;
border-radius: 5px;
box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
transition: transform 0.5s;

:hover{
    transform: scale(1.2);
}

@media (max-width: 768px){
    box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
    border: none;
    margin-bottom: 0px;

    :hover{
    transform: scale(0.8);
}
}
`;
export const ImageHolder = styled.div`
display: flex;
width: 150px;
height: 150px;
// background-color: brown;
border-radius: 100px;
margin-bottom: 5px;
`;
export const Image = styled.img`
width: 100%;
height: 100%;
object-fit: cover;
object-fit: contain;
border-radius: 100px;
`;
export const Name = styled.div`
display: flex;
justify-content: center;
// gap: 4px;
font-size: 16px;
`;
export const Surname = styled.div`
text-transform: capitalize;
font-weight: 700;
font-family: Poppins;
color: #0E8FD8;
margin-right: 4px;
`;
export const Firstname = styled.div`
text-transform: capitalize;
font-weight: 300;
font-family: Poppins;
color: #0E8FD8
`;
export const Career = styled.div`
margin: -5px;
color: #AA5D6A;
font-size: 12px;
letter-spacing: 3px;
`;
export const Work = styled.div`
margin: -5px;
color: #AA5D6A;
font-size: 12px;
margin-top: 3px;
font-size: 10px;
`;
export const Wish = styled.div`
// background-color: blue;
width: 400px;
display: flex;
flex-direction: column;
align-items: left;
padding-top: 20px;
padding-bottom: 20px;
// border: 1px solid #0E8FD8;
gap: 10px;
margin-left: 20px;
margin-right: 20px;

@media (max-width: 769px){
    display: none;
    gap: 5px;
}
`;
export const WishHeader = styled.div`
font-family: Kanit;
font-weight: 900;
font-size: 36px;
letter-spacing: 5px;
// color: #056988;
color: #000000;
`;
export const WishDesc = styled.div`
font-family: Kanit;
font-size: 16px;
color: #grey;
// color: #056988;
text-align: left;
line-height: 22px;
@media (max-width: 769px){
    margin-bottom: 20px;
}
`;
export const WishFooter = styled.div`
font-family: Kanit;
font-size: 18px;
text-transform: uppercase;
letter-spacing: 1px;
color: #D80E0E;
font-weight: 900;
`;
// export const BioWrapper = styled.div``;
// export const BioWrapper = styled.div``;
// export const BioWrapper = styled.div``;
// export const BioWrapper = styled.div``;